import { Controller } from 'cerebral';
import goalsModule from './goals-module';

export default Controller(goalsModule);
